module.exports = __webpack_public_path__ + "img/ubq.d17d3545.svg";